export default {
    open: "Antworte jetzt",
    approve: "Jetzt genehmigen",
    impersonation: {
        title: "Sie bestellen im Namen von «{name}»",
        cta: "Wechseln Sie zurück zu mir selbst",
    },
    "You have an unapproved orders": "Sie müssen Befehle genehmigen",
    "You have orders to approve": "Sie müssen Befehle genehmigen"
}